import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class SetTopReviewerAppStatusArgs {
  @Field(t => Int)
  userId!: number

  @Field(t => Int)
  newStatus!: number

  @Field({ nullable: true })
  statusReason?: string
}
